module.exports = __webpack_public_path__ + "static/media/step3.bed173b6.png";